import React from 'react'
import { ButtonLoginWrapper } from '../index.styled'

const ButtonLogin = ({ text, isBorder = false, onClick }) => (
	<ButtonLoginWrapper isBorder={isBorder} onClick={onClick}>{text}</ButtonLoginWrapper>
)

ButtonLogin.displayName = 'ButtonLogin'
export default ButtonLogin
